export default __webpack_public_path__ + "static/image-46-26ea4fc5d2051c28ecfdadcd68c6dad7.jpg";